import { render, staticRenderFns } from "./IconStudySetup.vue?vue&type=template&id=2f58a3f4&"
import script from "./IconStudySetup.vue?vue&type=script&lang=js&"
export * from "./IconStudySetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports